module.exports = __webpack_public_path__ + "img/Step12.ef5a5469.png";